import React from "react"
import { Select } from "./select"
import store, { qs } from "../store"
import { useStepIndex } from "./step-index-context"

//@ts-ignore
var _ = window._
export default function FunctionChooser({ disabled, changeHook }) {
  var stepIndex=useStepIndex()
  var ABI=store.steps[stepIndex].abi || []
  var value=[
    store.steps[stepIndex].abi ? store.steps[stepIndex].function_name : null,
    store.steps[stepIndex].abi ? store.steps[stepIndex].function_signature : null
  ]
  
  var a = ABI.filter(abiField => abiField.type == "function")
  var regularStyle = {
    display: "inline-block",
    padding: "2px 5px",
    background: "#eee",
    border: "1px solid black",
    cursor: "pointer",
  }

  store.useRerenderIfChange(()=>[
    store.steps[stepIndex].abi,
    store.steps[stepIndex].function_name,
    store.steps[stepIndex].function_signature
  ])

  

  const functionList = _.sortBy(a, "name")

  const functionsOrganized = {}
  const numFunctions = functionList.length
  for (let i = 0; i < numFunctions; i += 1) {
    const currentValue = functionList[i]
    const { name: functionName } = currentValue
    if (!functionsOrganized[functionName]) {
      functionsOrganized[functionName] = []
    }
    functionsOrganized[functionName].push(currentValue)
  }
  
  return (
    <div style={{ marginTop: 15, minWidth: '100%',maxWidth:450 }}>
      <Select
        disabled={disabled}
        label="Function"
        labelBackground="white"
        value={value}
        onChange={e => {
          var [newName,newSignature]=e.target.value.split(',')

          var step=store.steps[stepIndex]
          step.function_name = newName
          step.function_signature = newSignature
          step.parameters = []
          step.expected_output = []
          changeHook()
          store.updateStepFunctionsInUse(newName, store.currentStoryId, false);
          store.removeResults(stepIndex);
          store.updateStore()
        }}
        size="small"
        width="100%"
        wrapperWidth="100%"
      >
        {functionList.map((abiField, i) => 
            <option key={i} value={[abiField.name,abiField.signature]}>
              {functionNameFromField(abiField,functionList)}
            </option>
        )}
      </Select>
    </div>
  )
}


function functionNameFromField(abiField,functionList) {
  var values=[]
  if(functionList.filter(x=>x.name==abiField.name).length>1) {
    // two instances of the same functions. show arguments
    values.push(abiField.inputs.map(x=>x.type + ' ' + x.name).join(','))
  }
  if(abiField.constant) values.push("readonly")
  if(abiField.payable) values.push("payable")
  return abiField.name + (values.length>0 ? ' (' + values.join(', ') + ')' : '')
}